import type { MarketingActionScenario } from "src/types/action/MarketingActionScenario";
import type { MarketingActionSlotMetaData } from "src/types/action/MarketingActionSlotMetaData";
import { PositionEnum } from "src/types/trigger/TriggerPositionEnum";
import type { Channel } from "../channel";
import { type Offer, ScenarioSpecificActivationEnum } from "../offer";
import type { OfferStatus, ServiceTime } from "../offerSlot";
import type { Pos } from "../pos";
import type { SponsoredAd } from "../sponsored-ads";

export enum TriggerRefValueTypeEnum {
    ReferenceValue = "reference-value",
    TriggerLimit = "trigger-limit",
}

export interface TriggerRefValueType {
    [PositionEnum.Start]?: number | null;
    [PositionEnum.Stop]?: number | null;
    type?: TriggerRefValueTypeEnum | null;
    [ScenarioSpecificActivationEnum.Peak]?: string | null;
}

export interface MarketingActionSlot {
    id?: number;
    pos: Pos;
    posId: number;
    channel?: Channel;
    channelId?: number;
    serviceTime: ServiceTime;
    scheduledStartDateUTC: Date;
    scheduledEndDateUTC: Date;
    now: boolean;
    status?: OfferStatus;
    realStatus?: OfferStatus;
    remoteId?: string | null;
    performanceId?: number;
    isSpecial?: boolean;
    isCoFunded?: boolean;
    computationStartDateUTC: Date;
    computationEndDateUTC: Date;
    shiftedDate: string;
    offer?: Offer;
    sponsoredAd?: SponsoredAd;
    ancestorSlotId?: number;
    successor?: MarketingActionSlot;
    ancestor?: MarketingActionSlot;
    metaData?: MarketingActionSlotMetaData;
    triggerRefValues?: TriggerRefValueType;
    scenario?: MarketingActionScenario;
    scenarioId?: number;
    duoSlot?: any;
    isSchedulable: boolean;
}
